<button
    mat-icon-button
    [mat-menu-trigger-for]="Menu"
    [disabled]="disabled()"
    (keydown.arrowup)="onUpArrowPress()"
    (keydown.arrowdown)="onDownArrowPress()"
    (keydown.Tab)="onTabPress()">
    <mat-icon>more_horiz</mat-icon>
</button>
<mat-menu
    #Menu="matMenu"
    class="st-external-actions-overlay-menu">
    <ng-container>
        <mat-selection-list hideSingleSelectionIndicator>
            @for (action of actions(); track action?.ID; let i = $index) {
                @if (i === 0 && !inFullScreen()) {
                    <mat-list-option
                        class="st-external-actions-overlay-menu__option"
                        matListItem
                        [dir]="isRTL"
                        [matTooltip]="displayOpenActionButtonHoverTitle()"
                        (click)="onObjectOpen.emit()"
                        (keydown.space)="onObjectOpen.emit()">
                        <mat-icon
                            matListItemIcon
                            class="st-external-actions-overlay-icon"
                            >fullscreen</mat-icon
                        >
                        <div matListItemTitle>{{ displayOpenActionButtonLabel() }}</div>
                    </mat-list-option>
                }
                @if (data()?.visibilityCriteria[action?.ID] && editable()) {
                    <mat-list-option
                        class="st-external-actions-overlay-menu__option"
                        [matTooltip]="getExternaActionsHoverTitle(action)"
                        [dir]="isRTL"
                        (keydown.space)="actionChanged(action.ID)"
                        (click)="actionChanged(action.ID)">
                        @if (action.ID !== currentAction() && (!currentActionCompleted() || !currentActionError())) {
                            <mat-icon
                                matListItemIcon
                                fontSet="material-symbols-outlined"
                                class="st-external-actions-overlay-icon"
                                [style.background-image]="actionIcon(action)"
                                [class.st-external-actions-overlay-icon-delete]="action.ID === 'DELETE'">
                                {{ getIcon(action) }}
                            </mat-icon>
                        }
                        @if (currentActionError() && action.ID === currentAction()) {
                            <mat-icon
                                matListItemIcon
                                class="st-external-actions-overlay-icon-error">
                                error
                            </mat-icon>
                        }
                        @if (currentActionCompleted() && action.ID === currentAction()) {
                            <mat-icon matListItemIcon> check_circle </mat-icon>
                        }
                        @if (action.ID === currentAction() && !currentActionError() && !currentActionCompleted()) {
                            <st-loader
                                matListItemIcon
                                class="st-external-actions-overlay-loader"
                                [diameter]="25"
                                [strokeWidth]="4" />
                        }
                        <div
                            matListItemTitle
                            [class.st-external-actions-overlay-delete]="action.ID === 'DELETE'">
                            {{ getExternaActionsLabel(action) }}
                        </div>
                    </mat-list-option>
                }
            }
        </mat-selection-list>
    </ng-container>
</mat-menu>
